import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './config/amplify'
import { LoggerPlugin } from './utils/logger'

const app = createApp(App)
app.use(router)
app.use(LoggerPlugin)
app.mount('#app')
